import { smartStorage } from "@/helpers/index";
import * as helper from "@/helpers/index";

export const DOMAIN_SWITCHER_TYPES = {
  DESKTOP: "desktop",
  MOBILE: "mobile",
};

export const switchDomain = bundle => {
  const { id, domainName, plan } = bundle;
  domainName && smartStorage.setItem("domain", domainName);
  id && smartStorage.setItem("bundleId", id);

  // TODO: check if this is needed
  plan && smartStorage.setItem("plan", plan);

  let redirectTo = location.origin;
  // in case of dev builds, builds are deployed at /dev_builds/branch_name
  // this code ensures that when switching domains, we don't simply reload
  // the app with the origin, but instead reload with the entire dev build URL
  if (location.href.includes("dev_build")) {
    const lastSlashIndex = location.href.lastIndexOf("/");
    redirectTo = location.href.slice(0, lastSlashIndex);
  }
  helper.hardRedirect(redirectTo);
};

/**
 * Removes the domainName property from the given object.
 * @param {Object} obj
 * @returns {Object} new object without domainName
 */
export function removeDomainNamePropsFromObj(obj) {
  if (!obj || typeof obj !== "object") return obj;
  const rest = { ...obj };
  delete rest.domainName;
  return rest;
}
